import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import { ProviderServices } from '../CrudServices';
import useResponsive from '../../../hooks/useResponsive';
import { RoleGuard } from '../../../components/RoleGuard';
import { useParams } from 'react-router-dom';

const MissingServicesList = (props) => {
  const {isSm} = useResponsive();
  const {id} = useParams();

    /* =====================datagrid table related =========================*/
    const [loading, setLoading] = useState(false);
    const [allRowCount, setAllRowCount] = useState(0);
    const [controller, setController] = useState({
        page: 0,
        pageSize: 50,
        filters: {
          searchKey: "",
          status: 1,
        }
    });

    const handlePaginationChange = (newPagination) => {
        setController({
          ...controller,
          page: newPagination.page,
          pageSize: newPagination.pageSize
        });
    }

    const columns = [
        {
            field: 'serialNumber',
            headerAlign: 'center',
            headerName: 'S.No',
            width: 100,
            valueGetter: (params) => 
              controller.page * controller.pageSize + params.api.getRowIndexRelativeToVisibleRows(params.id)+1,
        },
        {
            field:'childService', headerAlign: 'center', headerName: "Child Service", flex: 3,editable: false,
            renderCell:(params)=>{
              return(
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  
                  <Typography variant='caption' sx={{ fontWeight: 600, fontSize: '0.7rem' }}>{` ${params.row?.title || ''} `}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{  fontWeight: 600, color: '#382cd5' }}>
                        _{params.row?.id}
                      </Box>
                    </RoleGuard>
                  
                  </Typography>
                </Box>
              )
            }
        },
        {
            field:'masterService', headerAlign: 'center', headerName: "Master Service", flex: 2,editable: false,
            renderCell:(params)=>{
              return(
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  <Typography variant='body2' sx={{ fontWeight: 600, fontSize: '0.7rem' }}>{params.row?.parentService?.title || ''}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{ fontSize: '.55rem', fontWeight: 600, color: '#382cd5' }}>
                        ({params.row?.parentServiceId})
                      </Box>
                    </RoleGuard>
                  </Typography>
                  
                </Box>
              )
            }
        },
        {
            field:'sub-category', headerAlign: 'center', headerName: "Sub-Category", flex: 2,editable: false,
            renderCell:(params)=>{
              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  <Typography variant='caption' sx={{ fontWeight: 600, fontSize: '0.7rem' }}>{` ${params.row?.ServiceCategoryRels[0]?.servCatId?.title || ''} `}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{  fontWeight: 600, color: '#382cd5' }}>
                        _{params.row?.ServiceCategoryRels[0]?.serviceCategoryId}
                      </Box>
                    </RoleGuard>
                  
                  </Typography>
                </Box>
              )
            }
        },
        {
            field:'category', headerAlign: 'center', headerName: "Category", flex: 2,editable: false,
            renderCell:(params)=>{
              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  <Typography variant='body2' sx={{ fontWeight: 600, fontSize: '0.7rem' }}>{params.row?.ServiceCategoryRels[0]?.servCatId?.parentCategory?.title || ''}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{ fontSize: '.55rem', fontWeight: 600, color: '#382cd5' }}>
                        ({params.row?.ServiceCategoryRels[0]?.servCatId?.parentId})
                      </Box>
                    </RoleGuard>
                  </Typography>
                  
                </Box>
              )
            }
        },
        
        // {
        //   field:'brands', headerAlign: 'center', headerName: "brands", flex: 1,editable: false,
        //   renderCell:(params)=>{  
        //     return(
        //       <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
        //         <Typography sx={{fontSize:'.75rem'}}>{params.row.serviceTime} mins.</Typography>
        //       </Box>
        //     )
        //   }
          
        // },
        // {field: 'action', headerAlign: 'center', headerName: 'Action', sortable: false, flex: 1,
        //   renderCell: (params) => {
        //     return (
        //       <Stack direction="row" spacing={1}>
        //         <IconButton
        //           onClick={() => onSelectForEdit(params.row)}
        //           size="small"
        //           color='warning'
        //         >
        //           <Edit fontSize="small" />
        //         </IconButton>
        //         <IconButton
        //           onClick={() => handleRemoveService(params.row.id)}
        //             color='error'
        //           size="small"
        //         >
        //           <DeleteIcon fontSize="small" />
        //         </IconButton>
        //       </Stack>
        //     );
        //   },
        // },
    ]
    const [missingServiceList,setMissingServiceList] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const fetchProviderMissingServiceList = async(fetchParameters)=>{
        setLoading(true);
       console.log("fetching serviceList Parameters:",fetchParameters)
        const missingListResponse = await ProviderServices.fetchMissingProviderServices(fetchParameters);
        console.log("missing provider service list Response:",missingListResponse)
        // setProviderServiceList(providerServiceListResponse?.data?.list);
        // const fetchedServiceList = providerServiceListResponse?.data?.list;
        // const newServiceList = fetchedServiceList.map(item => {
        //   return {
        //     id: item.id,
        //     servicesMasterId: item.servicesMasterId,
        //     servicesChildId: item.servicesChildId,
        //     subCategoryId: item.childService?.ServiceCategoryRels[0]?.serviceCategoryId,
        //     categoryId: item.childService?.ServiceCategoryRels[0]?.ServiceCategory?.cat.id,
        //     categoryTile: item.childService?.ServiceCategoryRels[0]?.ServiceCategory?.cat.title,
        //     subCategoryTitle: item.childService?.ServiceCategoryRels[0]?.ServiceCategory?.title,
        //     masterServiceTitle: item?.childService?.parentService?.title,
        //     childServiceTitle: item.childService?.title,
        //     serviceTime: item.serviceTime,
        //     price: item.price,
        //     visitingCharge: item?.providerServiceCharge?.vistingCharge
        //   };
        // });
        setMissingServiceList(missingListResponse?.data?.list);
        setAllRowCount(missingListResponse?.data?.totalItems)
        setLoading(false);
      }
  useEffect(()=>{
    if(id>0){
    fetchProviderMissingServiceList({
        providerId:id,
        page:controller.page+1,
        pageSize:controller.pageSize,
    });
    }
  },[controller,id]);
//   useEffect(()=>{
//     setAllRowCount(providerServiceModal?.totalItems);
//   },[])
  return (
    <>
        <Box sx={{ overflow: "auto" }}>
            <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff",borderRadius:'.5rem' }}>
                <DataGrid
                    rows={missingServiceList}
                    columns={columns.map((col) => ({
                      ...col,
                      // flex: isSmallScreen && (col.flex || 1), // Ensure columns resize dynamically
                      minWidth: isSm && (col.minWidth || 150), // Set a minimum width to avoid overlap
                    }))}
                    // getRowId={(row) => row.servicesChildId}
                    //checkboxSelection={true}
                    rowCount={allRowCount}  // Use the length of the filtered list
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    paginationModel={controller}
                    paginationMode="server"
                    onPaginationModelChange={handlePaginationChange}

                    loading={loading}

                    disableColumnMenu
                    disableRowSelectionOnClick
                    slots={{
                        // toolbar: GridToolbar,
                        noRowsOverlay: NoRowsLayout,
                    }}

                    autoHeight
                    getRowHeight={() => 'auto'}
                    sx={{
                      lineHeight:1,
                      '& .MuiDataGrid-cell': {
                        border: 1,
                        borderRight: 0,
                        borderTop: 0,
                        borderColor: 'lightgrey',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p:'.5%',fontSize:'.75rem'
                      },
                      '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                        borderTop: '2px solid rgba(224, 224, 224, 1)',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        p:0,
                        height: 'fit-content',
                        minHeight:'0 !important',
                        height:'2rem'
                      },
                      '& .MuiDataGrid-columnHeader': {
                        borderLeft: '1px solid rgba(224, 224, 224, 1)',
                        '&:last-child': {
                          borderRight: 'none',
                        },
                      },
                      '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 600,
                        color: '#3e3e3e'
                      },
                      '& .MuiDataGrid-row': {
                        '&:last-child .MuiDataGrid-cell': {
                          borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        },
                        '& .MuiDataGrid-cell:last-child': {
                          borderRight: 'none',
                        },
                      },
                      '& .MuiDataGrid-columnSeparator': {
                        display: 'none',
                      },
                    }}
                />
            </Box>
        </Box>
    </>
  );
}

export default MissingServicesList;
